<template>
    <div>

        <div class="profile-pets">
            <div class="profile-pets__content">

                <div class="profile-pets__body">

                    <div class="profile-pets__header" v-text="filter.title"></div>

                    <template v-if="!loading">
                        <div class="profile-pets__body-content d-flex" v-if="list.length">
                            <profile-pet :type="filter.petsType" v-for="(item, index) in list" :pet="item" :key="index"/>
                        </div>
                        <div class="profile-pets__body-content d-flex empty-list" v-else>
                            {{$store.getters.t(filter.petsType === 'projects' ? 'projects_list_empty' : 'tab_pet_empty_list')}}
                        </div>

                    </template>
                    <template v-else>
                        <div class="profile-pets__body-content profile-pets__body-content d-flex">
                            <div class="LoaderBalls">
                                <div class="LoaderBalls__item"></div>
                                <div class="LoaderBalls__item"></div>
                                <div class="LoaderBalls__item"></div>
                            </div>
                        </div>
                    </template>


                </div>

            </div>
        </div>

        <div class="row" v-if="pageCount > 1">
            <div class="col-md-12">
                <div class="pagination-area pull-right">
                    <nav class="navigation pagination" role="navigation">
                        <div class="nav-links">
                            <paginate
                                v-model="page"
                                :page-count="pageCount"
                                :click-handler="paginateClickCallback"
                                :prev-text="''"
                                :next-text="''"
                                :container-class="'className'"
                                :page-class="'page-numbers'"
                                :page-link-class="''"
                                :active-class="'current'"
                                :prev-class="'prev page-numbers'"
                                :prev-link-class="'lnr lnr-arrow-left'"
                                :next-class="'next page-numbers'"
                                :next-link-class="'lnr lnr-arrow-right'"
                            >
                            </paginate>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
import ProfilePet from './Profile/ProfilePet';
export default {
    name: "VolunteerActualPets",
    components: {
        ProfilePet
    },
    data() {
        return {
            appRoutes: null,
            pageCount: 1,
            loading: false,
            page: 1,
            list: []
        }
    },
    props: ['filter', 'user'],
    created() {
        this.appRoutes = window.appRoutes;
    },
    mounted() {
        this.getList();
    },

    computed:{
        userData(){
            return this.user ? this.user : this.$store.getters.getUserData;
        }
    },

    methods: {
        getList() {
            let self = this;
            let status = 1;
            let type = 'PET_TYPE_VOLUNTEER';

            let url = `/user/${this.userData.id}/pets`;

            let params = {
                page: self.page,
                per_page: 4,
                status: status,
                type: type,
                is_moderated: 1
            }

            if (self.filter.petsType === 'projects') {
                url = `/user/${this.userData.id}/projects`
            }

            if (self.filter.petsType === 'past') {
                params.status = 0;
                params.mode = 'past';
            }

            if (self.filter.petsType === 'personal') {
                params.type = 'PET_TYPE_MYSELF';
            }

            axios.get(url, {
                params: params
            })
                .then(response => {
                    response = response.data;
                    if (response.success) {
                        self.list = response.data;
                        self.pageCount = response.meta.last_page
                    } else {
                        alert(this.$store.getters.t('common_error_reload'));
                    }
                })
                .catch((error) => {

                })
                .then();

        },
        paginateClickCallback(pageNum) {
            this.page = pageNum;
        },
    },
    watch: {
        filter() {
            this.page = 1;
            this.getList();
        },
        page() {
            this.getList();
        },

        list(){
            this.loading = true;
            setTimeout(()=>{
                this.loading = false
            },1000)
        }

    }
}
</script>

<style lang="scss" scoped>

.LoaderBalls {
    margin: 0 auto;
    width: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__item {
        // .LoaderBalls__wrapper__item
        $anim-drt: 0.3s;
        $anim-ease: cubic-bezier(.6,.05,.15,.95);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #2E76E4;

        &:nth-child(1) {
            animation: bouncing $anim-drt alternate infinite $anim-ease;
        }

        &:nth-child(2) {
            animation: bouncing $anim-drt $anim-drt/4 alternate infinite $anim-ease backwards;
        }

        &:nth-child(3) {
            animation: bouncing $anim-drt $anim-drt/2 alternate infinite $anim-ease backwards;
        }
    }
}


@keyframes bouncing {

    0% {
        transform: translate3d(0, 10px, 0) scale(1.2, 0.85);
    }

    100% {
        transform: translate3d(0, -20px, 0) scale(0.9, 1.1);
    }
}

</style>
